import '../opentelemetry/logs/intrumentation';
import '../opentelemetry/traces/instrumentation';
import '../opentelemetry/metrics/instrumentation';
import '../opentelemetry/traces/web-vitals';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './lib/i18n';
import './styles/index.css';
import App from './App';
import { forceLogoutOnce } from './functions/forcedLogout';

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    environment: import.meta.env.VITE_SENTRY_ENV,
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.01,
    profilesSampleRate: 0.01,
    tracePropagationTargets: [/^https?:\/\/.*\/api(?:\/api.*)?$/],
  });
}

forceLogoutOnce();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
  <BrowserRouter>
    <StrictMode>
      <App />
    </StrictMode>
  </BrowserRouter>,
);
